import {toCurrency} from '@util/NumberUtil';

function convert ( val, opts ) {
    // default to $0.00 for non-convertable values
    return '$' + (
        (isNaN( val = parseFloat( val ) ))
            ? '0.00'
            : toCurrency( val, opts )
    );
};

export default Backbone.Model.extend( {
    toCurrency: function ( attr, opts ) {
        var val = this.get( attr );
        if ( typeof val == 'undefined' || null == val ) {
            console.warn( `Upi.Product.Currency: Cannot convert to currency because "${attr}" is not defined for Model` );
            return null;
        }

        if ( _.isArray( val ) ) {
            return _.map( val, function ( value ) {
                return convert( value, opts );
            } );
        }
        else if ( _.isObject( val ) ) {
            var copy = _.clone( val );
            return _.each( copy, function ( value, key ) {
                return copy[key] = convert( value, opts );
            } );
        }
        else {
            return convert( val, opts );
        }

    }
} );
